/**
 * Story Circles video modal – vanilla JS, no external dependencies.
 * Uses native <dialog> element for modal.
 * Module script executes after DOM is parsed, so no DOMContentLoaded needed.
 */

let _storyOverflowBefore = '';
function lockStoryScroll() {
  _storyOverflowBefore = document.documentElement.style.overflow;
  document.documentElement.style.overflow = 'hidden';
}
function unlockStoryScroll() {
  document.documentElement.style.overflow = _storyOverflowBefore;
  _storyOverflowBefore = '';
}

class StoryCircleModal extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          inset: 0;
          display: none;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.85);
          z-index: 9999;
        }
        dialog {
          border: none;
          border-radius: 12px;
          width: 92vmin;
          height: 92vmin;
          margin: 0 auto;
          padding: 0;
          background: var(--skydrift-bg, #0a0a0f);
          color: var(--skydrift-fg, #fff);
          position: relative;
        }
        dialog::backdrop {
          background: rgba(0,0,0,0.6);
        }
        video {
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: #000;
        }
        .close-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: transparent;
          border: none;
          color: var(--skydrift-fg, #fff);
          font-size: 2rem;
          cursor: pointer;
          width: 1.5rem;
          height: 1.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .close-btn::after {
          content: '×';
        }
        .close-btn:hover,
        .close-btn:focus-visible {
          color: var(--skydrift-cyan, #00f0ff);
        }
      </style>
      <dialog>
        <video controls autoplay muted loop></video>
        <button class="close-btn" aria-label="Close video" title="Close video"></button>
      </dialog>
    `;
  }

  connectedCallback() {
    const dialog = this.shadowRoot.querySelector('dialog');
    const closeBtn = this.shadowRoot.querySelector('.close-btn');

    if (!closeBtn) return;

    closeBtn.addEventListener('click', () => this.hide());
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) this.hide();
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.hide();
    });
  }

  show(videoUrl) {
    const video = this.shadowRoot.querySelector('video');
    if (!video || !videoUrl) return;
    video.src = videoUrl;
    video.load();
    video.play();
    this.style.display = 'flex';
    lockStoryScroll();
  }

  hide() {
    const video = this.shadowRoot.querySelector('video');
    if (video) {
      video.pause();
      video.src = '';
      video.load();
    }
    this.style.display = 'none';
    unlockStoryScroll();
  }
}

if (!customElements.get('story-circle-modal')) {
  customElements.define('story-circle-modal', StoryCircleModal);
}

const circles = document.querySelectorAll('.skydrift-story-circle');
if (circles.length > 0) {
  let modal = document.querySelector('story-circle-modal');
  if (!modal) {
    modal = document.createElement('story-circle-modal');
    document.body.appendChild(modal);
  }

  circles.forEach(circle => {
    circle.addEventListener('click', () => {
      const videoUrl = circle.getAttribute('data-video-url');
      if (videoUrl) {
        modal.show(videoUrl);
      }
    });
  });
}
